module.exports = __webpack_public_path__ + "a71f91628ac048b33b7413c7a7a8b7ce.svg";